export const AMPLITUDE_SESSION_REPLAY_CONFIG_PROXY_BASE_PATH =
  "/api/amplitude/session-replay/config";

export const AMPLITUDE_SESSION_REPLAY_TRACK_PROXY_PATH =
  "/api/amplitude/session-replay/track";

export const AMPLITUDE_SESSION_REPLAY_CONFIG_UPSTREAM =
  "https://sr-client-cfg.amplitude.com/config";

export const AMPLITUDE_SESSION_REPLAY_TRACK_UPSTREAM =
  "https://api-sr.amplitude.com/sessions/v2/track";

export function getAmplitudeSessionReplayProxyConfig() {
  return {
    configServerUrl: AMPLITUDE_SESSION_REPLAY_CONFIG_PROXY_BASE_PATH,
    trackServerUrl: AMPLITUDE_SESSION_REPLAY_TRACK_PROXY_PATH,
  };
}
